import { useCapabilities } from "store/capability-hooks";
import { Outlet } from "utils/routing";

export default function Layout() {
  const { canAccessMonitoringDashboard } = useCapabilities();
  if (!canAccessMonitoringDashboard) {
    return (
      <div className="flex h-full items-center justify-center">
        You are not authorized to access the monitoring dashboard.
      </div>
    );
  }

  return <Outlet />;
}
